exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1YqvjSa0vN1RoN1obxJjXM{padding-bottom:1rem}\n", ""]);

// exports
exports.locals = {
	"headline": "_1YqvjSa0vN1RoN1obxJjXM"
};